module.exports = __webpack_public_path__ + "static/media/A12.30964132.mp3";